import { ChevronRight, Home } from 'lucide-react'
import { LocalizedLink } from '@/components/LocalizedLink'
import { cn } from '@/lib/utils'

interface BreadcrumbItem {
  label: string
  to?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn('py-4 text-sm', className)}
    >
      <ol className="flex items-center flex-wrap gap-2">
        <li>
          <LocalizedLink
            to="home"
            className="flex items-center text-gray-500 hover:text-primary transition-colors"
          >
            <Home className="w-4 h-4" />
            <span className="sr-only">Home</span>
          </LocalizedLink>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            <ChevronRight className="w-4 h-4 text-gray-400" />
            {item.to ? (
              <LocalizedLink
                to={item.to}
                className="text-gray-500 hover:text-primary transition-colors"
              >
                {item.label}
              </LocalizedLink>
            ) : (
              <span className="text-primary font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
